import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, initialize } from "redux-form";
import { connect } from "react-redux";

import { sendNewletterRequest } from "../../actions";
import sendDetails from "./sendDetails.png";
import sendDetailsOver from "./sendDetails_over.png";
import sendDetailsBlack from "./sendDetailsBlack.png";

import closeIco from "./closeIco.png";
import closeIcoOver from "./closeIco_over.png";

export const fields = ["email", "city"];

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = "Falta o endereço de email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Endereço de email inválido.";
  }
  if (!values.city) errors.city = "Falta a cidade";

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div>
    <label>{label}</label>
    <div>
      <input {...input} className="form-control" type={type} />
      {touched &&
        ((error && <span>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
);

class NewsletterForm extends Component {
  state = {
    onBtnOver: false,
    onCloseOver: false
  };

  /*
  handleSubmit = (req, e) => {
    req.preventDefault();
    req.stopPropagation();


    const { dispatch } = this.props;
    // chamar uma acção para fazer o post dos dados
    dispatch(sendNewletterRequest(req));

    const initialFormData = ["email", "city"];

    dispatch(
      initialize(
        "newsletter",
        {
          email: "",
          city: ""
        },
        initialFormData
      )
    ); // clear form
  };
  */

  onOverBtn = () => {
    this.setState({
      onBtnOver: true
    });
  };

  onLeaveBtn = () => {
    this.setState({
      onBtnOver: false
    });
  };

  onOverCloseBtn = () => {
    this.setState({
      onCloseOver: true
    });
  };

  onLeaveCloseBtn = () => {
    this.setState({
      onCloseOver: false
    });
  };

  onCloseNewsLetterPanel = e => {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  renderSubmitButton = () => {
    return (
      <button
        className="pull-right btn-req-newsletter"
        type="submit"
        onMouseOver={this.onOverBtn}
        onMouseLeave={this.onLeaveBtn}
        disabled={this.props.submitting}
        /*
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
        */
      >
        ENVIAR{" "}
        {this.state.onBtnOver ? (
          <img src={sendDetailsOver} />
        ) : (
          <img src={sendDetails} />
        )}
      </button>
    );
  };

  render() {
    const {
      fields: { email, city },
      submitting,
      handleSubmit,
      successMsg
    } = this.props;

    if (this.props.standalone) {
      return (
        <form
          id="newsletterFrm"
          className={`${this.props.inClassName} standalone`}
          key="newsletter"
          onSubmit={handleSubmit}
        >
          <p className="title">Receba as nossas novidades no seu e-mail!</p>
          <div>
            <div>
              <Field
                component={renderField}
                name="email"
                label="Email"
                type="text"
              />
            </div>
          </div>
          <div>
            <div>
              <Field
                component={renderField}
                name="city"
                label="Cidade"
                type="text"
              />
            </div>
          </div>
          <div>
            {successMsg !== "" ? (
              <p className="feedback">{successMsg}</p>
            ) : null}

            <button
              className="pull-right btn-req-newsletter"
              type="submit"
              onMouseOver={this.onOverBtn}
              onMouseLeave={this.onLeaveBtn}
              disabled={this.props.submitting}
            >
              ENVIAR{" "}
              {this.state.onBtnOver ? (
                <img src={sendDetailsOver} />
              ) : (
                <img src={sendDetailsBlack} />
              )}
            </button>
          </div>
        </form>
      );
    }

    return (
      <form
        id="newsletterFrm"
        className={this.props.inClassName}
        key="newsletter"
        onSubmit={handleSubmit}
      >
        <p className="title">INSCRIÇÃO NEWSLETTER</p>
        <div>
          <div>
            <Field
              component={renderField}
              name="email"
              label="Email"
              type="text"
            />
          </div>
        </div>
        <div>
          <div>
            <Field
              component={renderField}
              name="city"
              label="Cidade"
              type="text"
            />
          </div>
        </div>
        <div>
          {successMsg !== "" ? (
            <p className="feedback">{successMsg}</p>
          ) : (
            <button
              className="pull-right btn-req-newsletter"
              type="submit"
              onMouseOver={this.onOverBtn}
              onMouseLeave={this.onLeaveBtn}
              disabled={this.props.submitting}
              /*
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
          */
            >
              ENVIAR{" "}
              {this.state.onBtnOver ? (
                <img src={sendDetailsOver} />
              ) : (
                <img src={sendDetails} />
              )}
            </button>
          )}
        </div>
        <button
          className="close-btn"
          onMouseOver={this.onOverCloseBtn}
          onMouseLeave={this.onLeaveCloseBtn}
          onClick={this.onCloseNewsLetterPanel}
        >
          {this.state.onCloseOver ? (
            <img src={closeIcoOver} />
          ) : (
            <img src={closeIco} />
          )}
        </button>
      </form>
    );
  }
}

NewsletterForm.propTypes = {
  fields: PropTypes.array.isRequired,
  inClassName: PropTypes.string.isRequired,
  successMsg: PropTypes.string,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  standalone: PropTypes.bool
};

NewsletterForm.defaultProps = {
  successMsg: `Obrigado por subscrever a newsletter.\nEm breve começará a receber regularmente as nossas publicações.`
};

NewsletterForm = reduxForm({
  form: "newsletter", // the name of your form and the key to
  fields: ["email", "city"], // a list of all your fields in your form
  validate // a synchronous validation function
})(NewsletterForm);

function mapStateToProps(state) {
  const { getNewsLetterState } = state;

  const { isFetchingNewsLetter, items: nletterState } = getNewsLetterState[
    "nletterState"
  ] || {
    isFetchingNewsLetter: true,
    items: {}
  };

  return {
    isFetchingNewsLetter,
    nletterState
  };
}

export default NewsletterForm;



// WEBPACK FOOTER //
// ./src/views/HomeView/NewsletterForm.js